import { types } from 'mobx-state-tree';

export interface IncomeOutgoingsSingleItemProps {
  date: number;
  income: number;
  outgoing: number;
  balance: number;
}

export const IncomeOutgoingsSingleItem = types.model({
  date: types.number,
  income: types.number,
  outgoing: types.number,
  balance: types.number,
});
